import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

export function DigitMemory({ onScore }) {
  const [phase, setPhase] = useState("idle"); // idle | show | input | wrong
  const [seq, setSeq] = useState("");
  const [shown, setShown] = useState("");
  const [input, setInput] = useState("");
  const [level, setLevel] = useState(0);
  const reported = useRef(false);

  const nextLevel = (lvl) => {
    const len = lvl + 2;
    let s = "";
    for (let i = 0; i < len; i++) s += Math.floor(Math.random() * 10);
    setSeq(s); setInput(""); setLevel(lvl); setShown(s); setPhase("show");
    const showMs = 800 + len * 350;
    setTimeout(() => { setShown(""); setPhase("input"); }, showMs);
  };

  const start = () => { reported.current = false; nextLevel(1); };

  const onChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    setInput(val);
    if (val.length === seq.length) {
      if (val === seq) setTimeout(() => nextLevel(level + 1), 400);
      else setPhase("wrong");
    }
  };

  useEffect(() => { if (phase === "wrong" && !reported.current) { reported.current = true; onScore?.((level - 1) * 100); } }, [phase, level, onScore]);

  return (
    <div className="flex flex-col items-center w-full max-w-md" data-testid="digit-memory">
      <p className="font-mono text-neon-cyan text-lg mb-5" data-testid="digit-level">LEVEL: {level}</p>

      {phase === "idle" && (
        <div className="text-center py-8">
          <p className="text-zinc-400 mb-4 max-w-xs">Memorize the number, then type it back. It gets longer each round!</p>
          <Button onClick={start} data-testid="digit-start" className="bg-neon-cyan text-black rounded-none font-bold uppercase h-12 px-8">
            <Play className="w-4 h-4 mr-2 fill-black" /> Start
          </Button>
        </div>
      )}

      {phase === "show" && (
        <div className="py-10 text-center">
          <p className="font-display font-black text-5xl tracking-[0.3em] text-neon-yellow" data-testid="digit-shown">{shown}</p>
          <p className="text-zinc-500 text-sm mt-4 font-mono">Memorize…</p>
        </div>
      )}

      {phase === "input" && (
        <div className="py-8 w-full text-center">
          <input autoFocus value={input} onChange={onChange} data-testid="digit-input" inputMode="numeric"
            className="w-full bg-zinc-950 border-2 border-neon-cyan rounded-lg px-4 py-4 text-center font-display font-black text-3xl tracking-[0.3em] text-white outline-none"
            placeholder="• • •" />
          <p className="text-zinc-500 text-sm mt-3 font-mono">Type the number</p>
        </div>
      )}

      {phase === "wrong" && (
        <div className="py-8 text-center" data-testid="digit-wrong">
          <p className="font-display font-black text-2xl text-neon-pink uppercase">Wrong!</p>
          <p className="text-zinc-300 mt-1">The number was <span className="text-neon-yellow font-mono">{seq}</span></p>
          <p className="text-zinc-400 mt-1">You reached level {level}</p>
          <Button onClick={start} className="mt-4 bg-neon-cyan text-black rounded-none font-bold uppercase">Try Again</Button>
        </div>
      )}
    </div>
  );
}
